<template>
	<div class="template text" v-show="dataVal.IsShow || dataVal.IsShow == null">
		<div class="panel_wrap">
			<label class="panel_title">{{dataVal.Property.Title[0].Text}}<span v-show="dataVal.Property.Require==1" class="require">*</span>
			</label>
			<input class="input_value" @blur.prevent="changeCount(dataVal.Property.Title[0].Text)" v-model="dataVal.Value" :readOnly="dataVal.Disable|| dataVal.Property.Title[0].Text=='签约时间'||dataVal.Property.Title[0].Text=='代码'||dataVal.Property.Title[0].Text=='晋升职位'||dataVal.Property.Title[0].Text=='原职位'||dataVal.Property.Title[0].Text=='部门'||dataVal.Property.Title[0].Text=='职位'||dataVal.Property.Title[0].Text=='人员'||dataVal.Property.Title[0].Text=='工号'||dataVal.Property.Title[0].Text=='入职时间'||dataVal.Property.Title[0].Text=='联系电话'||dataVal.Property.Title[0].Text=='申请时间'||dataVal.Property.Title[0].Text=='端口费用承担部门'" :placeholder="dataVal.Property.Placeholder[0].Text==''?'请输入':dataVal.Property.Placeholder[0].Text " />
		</div>
	</div>
</template>

<script>
	import {
		Message
	} from 'element-ui'
	export default {
		props: ['dataVal'],
		data() {
			return {

			}
		},
		mounted() {

		},
		methods: {
			changeCount(val) {
				if (val == "电话号码" && this.dataVal.Value != null) {
					if (!(/^1[3456789]\d{9}$/.test(this.dataVal.Value))) {
						Message({
							message: "手机号码有误，请重填",
							type: 'error',
							duration: 3 * 1000
						});
						this.dataVal.Value = null;
						return;
					}
				}
				this.$emit('child-event', this.dataVal.Value, val);
			}
		}
	}
</script>

<style>
	@import '../../assets/css/common.css';
</style>
